<button class="dark:text-orange_light text-vivid-royal-400" type="button" [ngStyle]="{'color':color}" [ngClass]="{'underline':!hasIcon}"
    (click)="onClick.emit(true)">@if(hasIcon){<span [innerHTML]="iconSvg"></span>}
    {{showButtonText?textButton:''}}</button>
